import { render, staticRenderFns } from "./lantern-loader.vue?vue&type=template&id=6db8e159&"
import script from "./lantern-loader.vue?vue&type=script&lang=ts&"
export * from "./lantern-loader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports